<template>
  <div>
    <h1 class="text-center">
      Страница не найдена
    </h1>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ErrorPage extends Vue {}
</script>

<style scoped></style>
